<template>
  <el-dialog :visible.sync="dialogVisible" width="900px" :show-close="false">
    <img
      class="close-img"
      alt="close-icon.png"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="dialog-title">
      {{ $t("exchangeHKD.title", { coin: exchangeCoin }) }}
    </p>
    <div class="exchange-content" v-loading="loading">
      <!-- 兑换引导 -->
      <div class="guide-section">
        <p class="guide-title">{{ $t("exchangeHKD.how_to_exchange") }}</p>
        <div class="guide-steps">
          <div class="guide-step-item" v-for="(item, index) in guideList" :key="index">
            <span class="step-num">{{ index + 1 }}</span>
            <span class="step-text">{{ $t("exchangeHKD." + item.stepKey) }}</span>
          </div>
        </div>
      </div>

      <!-- 转账数量和可得数量 -->
      <div class="section-card">
        <div class="input-section">
          <p class="input-label">{{ $t("exchangeHKD.transfer_amount") }}</p>
          <div class="input-wrapper">
            <el-input
              v-model="form.amount"
              :placeholder="$t('exchangeHKD.input_amount_placeholder')"
              type="number"
              class="amount-input"
              maxlength="12"
            />
            <span class="currency-suffix">{{ exchangeBase }}</span>
          </div>
        </div>
        <div class="input-section">
          <div class="input-header">
            <span class="input-label">{{ $t("exchangeHKD.ht_amount", { coin: exchangeCoin }) }}</span>
            <span class="rate-text">{{ $t("exchangeHKD.rate") }} 1{{ exchangeBase }} = {{ exchangeRate }} {{ exchangeCoin }}</span>
          </div>
          <div class="input-wrapper">
            <el-input
              :value="calculatedHTAmount"
              :placeholder="$t('exchangeHKD.ht_amount', { coin: exchangeCoin })"
              class="amount-input"
              :disabled="true"
            />
          </div>
        </div>

        <!-- 收款账户信息 -->
        <div class="receipt-info">
          <p class="receipt-title">{{ $t("exchangeHKD.receipt_account") }}</p>
          <div class="receipt-item">
            <span class="receipt-label">{{ $t("exchangeHKD.account_number") }}</span>
            <div class="receipt-value-wrapper">
              <span class="receipt-value">{{ bankInfo.receiveAccount || "-" }}</span>
              <i class="el-icon-document copy-icon" @click="copyText(bankInfo.receiveAccount)" />
            </div>
          </div>
          <div class="receipt-item">
            <span class="receipt-label">{{ $t("exchangeHKD.company") }}</span>
            <div class="receipt-value-wrapper">
              <span class="receipt-value">{{ bankInfo.company || "-" }}</span>
              <i class="el-icon-document copy-icon" @click="copyText(bankInfo.company)" />
            </div>
          </div>
          <div class="receipt-item">
            <span class="receipt-label">{{ $t("exchangeHKD.bank") }}</span>
            <div class="receipt-value-wrapper">
              <span class="receipt-value">{{ bankInfo.bankName || "-" }}</span>
              <i class="el-icon-document copy-icon" @click="copyText(bankInfo.bankName)" />
            </div>
          </div>
        </div>
      </div>

      <!-- 转账信息表单 -->
      <div class="section-card form-card">
        <p class="form-title">{{ $t("exchangeHKD.form_title") }}</p>
        <el-form label-position="top" class="exchange-form">
          <el-form-item required>
            <span slot="label">{{ $t("exchangeHKD.transfer_account") }}</span>
            <el-input
              v-model="form.account"
              :placeholder="$t('exchangeHKD.input_placeholder')"
              maxlength="30"
            />
          </el-form-item>
          <el-form-item required>
            <span slot="label">{{ $t("exchangeHKD.transfer_name") }}</span>
            <el-input
              v-model="form.name"
              :placeholder="$t('exchangeHKD.input_placeholder')"
              maxlength="30"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t("exchangeHKD.transfer_serial") }}</span>
            <el-input
              v-model="form.transactionNo"
              :placeholder="$t('exchangeHKD.input_placeholder')"
              maxlength="30"
            />
          </el-form-item>
        </el-form>
      </div>

      <!-- 提示信息 -->
      <div class="tips-section">
        <div class="tip-item" v-for="i in 4" :key="i">
          <span class="tip-icon">{{ i }}</span>
          <span class="tip-text">{{ $t("exchangeHKD.tip" + i) }}</span>
        </div>
      </div>

      <!-- 底部操作 -->
      <div class="footer-section">
        <el-button
          type="primary"
          class="submit-btn"
          :loading="submitting"
          @click="handleSubmit"
        >
          {{ $t("exchangeHKD.complete_transfer") }}
        </el-button>
      </div>
    </div>

    <!-- 二次确认弹窗 -->
    <el-dialog
      :visible.sync="showConfirmModal"
      :title="$t('exchangeHKD.confirm_modal_title')"
      width="400px"
      append-to-body
    >
      <p class="confirm-content">{{ $t("exchangeHKD.confirm_modal_content") }}</p>
      <span slot="footer">
        <el-button @click="showConfirmModal = false">{{ $t("exchangeHKD.confirm_modal_cancel") }}</el-button>
        <el-button type="primary" @click="confirmSubmit">{{ $t("exchangeHKD.confirm_modal_confirm") }}</el-button>
      </span>
    </el-dialog>

    <!-- 成功提示弹窗 -->
    <el-dialog
      :visible.sync="showSuccessModal"
      :title="$t('exchangeHKD.success_modal_title')"
      width="400px"
      append-to-body
      :show-close="false"
    >
      <p class="success-content">{{ $t("exchangeHKD.success_modal_content") }}</p>
      <span slot="footer">
        <el-button type="primary" @click="handleSuccessConfirm">{{ $t("exchangeHKD.success_modal_btn") }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["errorCode"]),
    calculatedHTAmount() {
      const amount = parseFloat(this.form.amount);
      if (!amount || amount <= 0) return "0.00";
      return (amount * this.exchangeRate).toFixed(2);
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      showConfirmModal: false,
      showSuccessModal: false,
      coin: "",
      exchangeRate: 0,
      exchangeCoin: "",
      exchangeBase: "HKD",
      guideList: [
        { stepKey: "step1" },
        { stepKey: "step2" },
        { stepKey: "step3" },
      ],
      form: {
        amount: "",
        account: "",
        name: "",
        transactionNo: "",
      },
      bankInfo: {
        receiveAccount: "",
        company: "",
        bankName: "",
      },
    };
  },
  methods: {
    initDialog(rate) {
      this.dialogVisible = true;
      this.form = { amount: "", account: "", name: "", transactionNo: "" };
      if (rate) {
        this.coin = rate.coin || "";
        this.exchangeRate = parseFloat(rate.rate) || 0;
        this.exchangeCoin = rate.coin || "";
        this.exchangeBase = rate.base || "HKD";
      }
      this.getHKDAccount();
      if (!this.exchangeRate) {
        this.getExchangeRate();
      }
    },
    getExchangeRate() {
      const params = {};
      if (this.coin) {
        params.coinType = this.coin;
      }
      this.$axios
        .post("/userAssets/depositHKDExchangeRate", params)
        .then((res) => {
          if (res.data.code === this.errorCode.ok && res.data.data) {
            let target = res.data.data;
            if (Array.isArray(res.data.data)) {
              target = this.coin
                ? res.data.data.find((item) => item.coin === this.coin)
                : res.data.data[0];
            }
            if (target && target.rate) {
              this.exchangeRate = parseFloat(target.rate);
              this.exchangeCoin = target.coin || "";
              this.exchangeBase = target.base || "";
            }
          }
        })
        .catch(() => {});
    },
    getHKDAccount() {
      this.$axios
        .post("/userAssets/depositHKDAccount", { coinType: "HKD" })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.bankInfo = res.data.data || {};
          }
        })
        .catch(() => {});
    },
    copyText(text) {
      if (!text) return;
      this.$copyText(text).then(
        () => {
          this.$message.success(this.$t("exchangeHKD.copy_success"));
        },
        () => {},
      );
    },
    validateForm() {
      const amount = parseFloat(this.form.amount);
      if (!amount || amount < 100) {
        this.$message.warning(this.$t("exchangeHKD.min_amount_tip"));
        return false;
      }
      if (!this.form.account || !this.form.account.trim()) {
        this.$message.warning(this.$t("exchangeHKD.input_transfer_account"));
        return false;
      }
      if (!this.form.name || !this.form.name.trim()) {
        this.$message.warning(this.$t("exchangeHKD.input_transfer_name"));
        return false;
      }
      return true;
    },
    handleSubmit() {
      if (!this.validateForm()) return;
      this.showConfirmModal = true;
    },
    confirmSubmit() {
      this.showConfirmModal = false;
      this.submitting = true;
      this.$axios
        .post("/userAssets/depositHKD", {
          coinType: this.coin,
          amount: this.form.amount,
          transferAccount: this.form.account,
          transferName: this.form.name,
          transactionNo: this.form.transactionNo,
          memo: JSON.stringify({
            actionType: "exchange",
            bankInfo: {
              receiveAccount: this.bankInfo.receiveAccount,
              receiveCompany: this.bankInfo.company,
              receiveBankName: this.bankInfo.bankName,
            },
            transferInfo: {
              transferName: this.form.name,
              transferAccount: this.form.account,
              transferNumber: this.form.transactionNo,
              transferAmount: this.form.amount,
            },
            exchangeInfo: {
              exchangeCoin: this.exchangeCoin,
              exchangeBase: this.exchangeBase,
              exchangeRate: this.exchangeRate,
              transferAmount: this.form.amount,
              exchangeAmount: this.calculatedHTAmount,
            },
          }),
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.showSuccessModal = true;
          } else {
            this.$message.error(res.data.msg || this.$t("exchangeHKD.submit_fail"));
          }
        })
        .catch(() => {
          this.$message.error(this.$t("exchangeHKD.submit_fail"));
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleSuccessConfirm() {
      this.showSuccessModal = false;
      this.dialogVisible = false;
      this.$emit("success");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px;
  .el-dialog__body {
    padding-top: 0px;
    position: relative;
  }
}

.close-img {
  top: -10px;
  right: 20px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
  z-index: 10;
}

.dialog-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
  margin-bottom: 20px;
}

.exchange-content {
  max-height: 600px;
  overflow-y: auto;
}

.guide-section {
  background: #f8f9ff;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 16px;

  .guide-title {
    font-size: 15px;
    font-weight: 600;
    color: #333333;
    margin: 0 0 12px 0;
  }

  .guide-steps {
    display: flex;
    gap: 20px;

    .guide-step-item {
      display: flex;
      align-items: center;
      flex: 1;

      .step-num {
        width: 20px;
        height: 20px;
        background: var(--primary-color);
        color: #ffffff;
        border-radius: 50%;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .step-text {
        font-size: 13px;
        color: #666666;
      }
    }
  }
}

.section-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
}

.input-section {
  margin-bottom: 20px;

  .input-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .input-label {
    font-size: 14px;
    font-weight: 500;
    color: #767676;
    margin: 0 0 12px 0;
  }

  .rate-text {
    font-size: 13px;
    color: #767676;
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    background: #f8f9fa;
    border-radius: 10px;
    padding: 0 16px;

    /deep/ .amount-input .el-input__inner {
      border: none;
      background: transparent;
      font-size: 16px;
      color: #1f2329;
      padding: 0;

      &:disabled {
        color: #1f2329;
        cursor: default;
      }
    }

    .currency-suffix {
      width: 48px;
      font-size: 14px;
      color: #999999;
      margin-left: 8px;
    }
  }
}

.receipt-info {
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
  margin-top: 4px;

  .receipt-title {
    font-size: 14px;
    font-weight: 500;
    color: #1f2329;
    margin: 0 0 16px 0;
  }

  .receipt-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }

    .receipt-label {
      font-size: 13px;
      color: #666666;
      flex-shrink: 0;
    }

    .receipt-value-wrapper {
      display: flex;
      align-items: center;

      .receipt-value {
        font-size: 13px;
        color: #1f2329;
        margin-right: 8px;
        text-align: right;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .copy-icon {
        color: var(--primary-color);
        cursor: pointer;
        font-size: 14px;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}

.form-card {
  .form-title {
    font-size: 14px;
    color: #1f2329;
    margin: 0 0 16px 0;
  }

  /deep/ .exchange-form .el-form-item__label {
    font-size: 14px;
    color: #1f2329;
    padding-bottom: 8px;
  }

  /deep/ .exchange-form .el-input__inner {
    background: #f8f9fa;
    border: none;
    border-radius: 10px;
  }
}

.tips-section {
  padding: 0 4px;
  margin-bottom: 20px;

  .tip-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;

    .tip-icon {
      width: 18px;
      height: 18px;
      background: #f0f0f0;
      color: #999999;
      border-radius: 50%;
      font-size: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      flex-shrink: 0;
      margin-top: 2px;
    }

    .tip-text {
      font-size: 13px;
      color: #999999;
      line-height: 1.6;
      flex: 1;
    }
  }
}

.footer-section {
  .submit-btn {
    width: 100%;
    height: 44px;
    background: var(--primary-color);
    border-color: var(--primary-color);
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;

    &:hover {
      background: #3352e0;
      border-color: #3352e0;
    }
  }
}

.confirm-content,
.success-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
  margin: 0;
}
</style>
